module.exports = new __parcel__URL__("service-worker.js").toString();